import React, { useState } from "react";
import { requestMagicLink } from "@/api";

export default function Login() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | sending | sent | error
  const [message, setMessage] = useState("");
  const [devLink, setDevLink] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setStatus("sending");
    setMessage("");
    setDevLink("");
    try {
      const res = await requestMagicLink(email.trim());
      setStatus("sent");
      if (res.email_sent) {
        setMessage(`Check your inbox — we sent a one-click sign-in link to ${email.trim()}. It expires in 30 minutes.`);
      } else {
        setMessage("Email delivery isn't configured yet, so here is your sign-in link for now:");
        setDevLink(res.dev_link || "");
      }
    } catch (err) {
      setStatus("error");
      setMessage(err?.response?.data?.detail || "Something went wrong. Please try again.");
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-card" data-testid="login-card">
        <div className="auth-head">
          <div className="auth-eyebrow"><span className="eyebrow-dot" /> Lonesome Cactus Studio</div>
          <h1 className="auth-title">Get your story found<br /><em>one effort at a time.</em></h1>
        </div>
        <div className="auth-body">
          <p className="auth-desc">
            Enter the email you used in your Findability Session. We'll send a one-click sign-in link —
            no password needed. Your saved posts and progress travel with you across every device.
          </p>
          <form onSubmit={submit}>
            <div className="auth-field">
              <label htmlFor="authEmail">Your Email</label>
              <input
                id="authEmail"
                type="email"
                autoComplete="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                required
              />
            </div>
            <button
              type="submit"
              className="auth-btn"
              disabled={status === "sending"}
              data-testid="login-submit-button"
            >
              {status === "sending" ? "Sending your link…" : "Send my sign-in link →"}
            </button>
          </form>

          {message && (
            <div className={`auth-msg ${status === "error" ? "err" : "ok"}`} data-testid="login-message">
              {message}
              {devLink && (
                <div className="auth-devlink">
                  <a href={devLink} data-testid="login-dev-link">{devLink}</a>
                </div>
              )}
            </div>
          )}

          <div className="auth-foot">
            🌵 New here? Just enter your email above — we'll create your account automatically the first time you sign in.
          </div>
        </div>
      </div>
    </div>
  );
}
